module.exports = __webpack_public_path__ + "img/hobi_logo.9642ea58.png";